// Import dependencies
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as msal from "@azure/msal-browser";
// Import actions
import { fetchLoginData, resetLoginData } from "./store/actions";

// Import component and configuration
import { xanturaLogo } from "../../assets/icons";
import { InputField } from "../../components";
import { ResetPasswordModal, AuthIdentificationModal, ContentType } from "./component";
import { MSAL_CONFIG, MSAL_LOGINREQUEST } from "../../config";
import { loginFormState } from "../../interfaces";
import { Link } from "react-router-dom";
import { isLogin } from "../../store/actions/ui-actions";
import { TOKEN, setData } from "../../utils/Storage";
import { resetLogoutFlag } from "../../utils";

// Component initiliazation
const Auth = () => {
  // call of the hook to dispatch the action for tha API
  const dispatch = useDispatch();

  // Create a new instance of MSAL
  const msalInstance = new msal.PublicClientApplication(MSAL_CONFIG);

  //   getting the response of the API
  const loginData: any = useSelector<any>((state) => state.loginData);

  //   state for the loign
  const [state, setState] = useState<loginFormState>({
    formData: {
      passWord: "",
      userName: "",
    },
    formError: {
      userName: false,
      passWord: false,
    },
    secondValidation: "",
    validate: false,
    showPassCodePopup: false,
    showEmailMFAPopup: false
  });

  const [tempToken, setTempToken] = useState<string>("");
  const [resetPasswordShow, setResetPasswordShow] = useState(false);
  const [resetPasscodeShow, setResetPasscodeShow] = useState(false);

  //   handle the error and also dispatch the action to the API

  useEffect(() => {
    if (loginData.isSuccess && loginData.data !== null) {
      setTempToken(loginData.data.userToken);

      if (loginData.data.isPasswordChangeRequired) {

        setState({
          ...state,
          secondValidation: loginData.data,
        });

        setResetPasswordShow(true);
      } else if (loginData.data.isPasscodeChangeRequired) {
        setState({
          ...state,
          secondValidation: loginData.data,
        });
        setResetPasscodeShow(true);
      } else {
        setState({
          ...state,
          showPassCodePopup: true,
          showEmailMFAPopup: loginData.data.isMFALogin,
          secondValidation: loginData.data.secondaryAuthenticationPart,
        });
      }

      dispatch(resetLoginData());
    } else if (loginData.isError) {
      dispatch(resetLoginData());
    }
  }, [loginData]);

  // function to handle the validation of the form Submit
  useEffect(() => {
    if (state.formData.userName !== "" && state.formData.passWord !== "") {
      setState({ ...state, validate: false });
    } else {
      setState({ ...state, validate: true });
    }
  }, [state.formData]);

  // function to handle the change and update the value in the state for the username and password
  const __onChange = (e: any) => {
    if (e.target.value !== "") {
      setState({
        ...state,
        formData: { ...state.formData, [e.target.name]: e.target.value },
        formError: { ...state.formError, [e.target.name]: false },
      });
    } else {
      setState({
        ...state,
        formData: { ...state.formData, [e.target.name]: e.target.value },
        formError: { ...state.formError, [e.target.name]: true },
      });
    }
  };

  //   Function to submit the Login form data
  const __loginFormSubmit = (event: any) => {
    event.preventDefault();
    if (state.formData.userName !== "" && state.formData.passWord !== "") {
      setState({ ...state, validate: false });
    } else {
      setState({
        ...state,
        validate: true,
        formError: { ...state.formError, userName: true, passWord: true },
      });
    }

    // dispatch and API request
    dispatch(fetchLoginData(state.formData));
  };

  const __loginWithAzure = async () => {
    try {

      // initialize MSAL
      await msalInstance.initialize();

      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
      }

      // Attempt to perform Single Sign-On (SSO)

      await msalInstance.acquireTokenPopup({ ...MSAL_LOGINREQUEST, prompt: accounts.length > 0 ? "none" : "select_account" }).then((res) => {
        // Set the active account upon successful token acquisition
        msalInstance.setActiveAccount(res.account)

        // Reset the logout flag before setting new token and reloading
        resetLogoutFlag();

        setData(TOKEN, { token: res.accessToken, provider: 'msal' });
        dispatch(isLogin({ token: res.accessToken, isLegacy: false, provider: "msal" }))

        window.location.reload();
      });
    } catch (e) {
      // Set authentication error state if token acquisition fails
      // setAuthError(e)
      console.log(e)
    }
  }

  return (
    <>
      <div className="login-container">
        <div className="image-container">
          <img src={xanturaLogo} alt="Xantura Logo" />
        </div>

        {/* Login form  */}
        <form
          className="need-validated"
          noValidate
          onSubmit={(e) => __loginFormSubmit(e)}
        >
          {/* field to enter username  */}
          <InputField
            title="Login"
            placeholder="Login name"
            name="userName"
            value={state.formData.userName}
            type="text"
            onChange={__onChange}
            error={state.formError.userName}
          />

          {/* field to enter password */}
          <div className="password-container">
            <InputField
              title="Password"
              name="passWord"
              placeholder="Password"
              value={state.formData.passWord}
              type="password"
              onChange={__onChange}
              error={state.formError.passWord}
            />

            {/* TODO: please create forget password page */}
            <Link to="/forgetPassword" title="Forgotten your password?">
              Forgotten your password?
            </Link>
          </div>

          <div className="button-container">
            <button
              disabled={state.validate}
              style={state.validate ? { opacity: 0.5 } : { opacity: 1 }}
              type="submit"
            >
              Login
            </button>
            <span>OR</span>

            <button onClick={() => __loginWithAzure()} type="button">Login using Azure AD</button>
          </div>
        </form>
      </div>


      {
      state.showPassCodePopup ?
        <AuthIdentificationModal
          tempToken={tempToken}
          contentType={state.showEmailMFAPopup ? ContentType.EMAIL_MFA : ContentType.PASSCODE}
          secondaryAuthenticationPart={state.showEmailMFAPopup ? [1, 2, 3, 4, 5, 6] : state.secondValidation}
          onClose={() => setState({ ...state, showPassCodePopup: false, })}
        />
        : null
      }

      {/* {state.formSubmitted ? (
        <div className="login-popup">
          <Popup
            header={
              state.showPassCodePopup
                ? __renderPassCodePopupHeader()
                : state.formSubmitted
                  ? __renderLoginError()
                  : null
            }
            content={
              state.showPassCodePopup
                ? 
                state.showEmailMFAPopup ? __renderEmailMFAPopup() : 
                __renderPassCodeFields()
                : state.formSubmitted
                  ? __renderLoginContent()
                  : null
            }
            footer={null}
          />
        </div>
      ) : null} */}


      {/* TODO: reset password fields */}
      {resetPasswordShow ? (
        <ResetPasswordModal
          token={tempToken}
          closeModal={() => setResetPasscodeShow(false)} />
      ) : null}


      {/* TODO: reset passcode fields  */}
      {/* {resetPasscodeShow ? (
        <div className="login-popup">
          <Popup
            header={__renderResetPasscodeTitle()}
            content={__renderPassCodeFields()}
            footer={null}
          />
        </div>
      ) : null} */}
    </>
  );
};

export default Auth;
